export default "__VITE_ASSET__CcL8X0OY__"